// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class LoginPageGuard  {

  constructor() {

  }

  canActivate(): boolean {
    return true;
    
  }

}